/** English label for an ISO 3166-1 alpha-2 code (best effort). */
export function countryLabel(code: string | undefined | null): string {
  const c = code?.trim().toUpperCase();
  if (!c || c.length !== 2) return code?.trim() || 'Unknown';
  try {
    if (typeof Intl !== 'undefined' && 'DisplayNames' in Intl) {
      const dn = new Intl.DisplayNames(['en'], { type: 'region' });
      const name = dn.of(c);
      if (name && name !== c) return name;
    }
  } catch {
    /* ignore */
  }
  return c;
}

/** Sorted { value, label } for country <Select> (all alpha-2 regions Intl names). */
export function buildCountrySelectOptions(): { value: string; label: string }[] {
  const out: { value: string; label: string }[] = [];
  try {
    if (typeof Intl !== 'undefined' && 'DisplayNames' in Intl) {
      const dn = new Intl.DisplayNames(['en'], { type: 'region' });
      for (let i = 65; i <= 90; i += 1) {
        for (let j = 65; j <= 90; j += 1) {
          const value = `${String.fromCharCode(i)}${String.fromCharCode(j)}`;
          const label = dn.of(value);
          if (label && label !== value) out.push({ value, label });
        }
      }
      out.sort((a, b) => a.label.localeCompare(b.label));
      return out;
    }
  } catch {
    /* fall through */
  }
  return [
    { value: 'CA', label: 'Canada' },
    { value: 'US', label: 'United States' },
    { value: 'GB', label: 'United Kingdom' },
    { value: 'FR', label: 'France' },
    { value: 'DE', label: 'Germany' },
  ];
}

/** Cached options for server modals (built once at module load). */
export const COUNTRY_SELECT_OPTIONS = buildCountrySelectOptions();
